/** Formatação para exibição (pt-BR, fuso de operação). */
const TZ = 'America/Sao_Paulo';

export const brl = (cents: number | null | undefined) =>
  ((cents ?? 0) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export const date = (d: string | Date | null | undefined) =>
  d ? new Date(d).toLocaleDateString('pt-BR', { timeZone: TZ }) : '—';

export const dateTime = (d: string | Date | null | undefined) =>
  d ? new Date(d).toLocaleString('pt-BR', { timeZone: TZ, day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—';

export const time = (d: string | Date | null | undefined) =>
  d ? new Date(d).toLocaleTimeString('pt-BR', { timeZone: TZ, hour: '2-digit', minute: '2-digit' }) : '—';

export const weekdayShort = (d: string | Date) => new Date(d).toLocaleDateString('pt-BR', { timeZone: TZ, weekday: 'short' }).replace('.', '');

/** Data sem hora vinda da API ("1988-03-14") — evita deslocamento de fuso. */
export const isoDateBr = (iso: string | null | undefined) => (iso ? iso.slice(0, 10).split('-').reverse().join('/') : '—');

export const formatCpf = (cpf: string) => cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
export const formatPhone = (p?: string | null) => (p ? p.replace(/^55/, '').replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3') : '—');

/** "há 5 min" */
export function relative(d: string | Date) {
  const diff = (Date.now() - new Date(d).getTime()) / 1000;
  if (diff < 60) return 'agora';
  if (diff < 3600) return `há ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `há ${Math.floor(diff / 3600)} h`;
  return date(d);
}

/** mm:ss a partir de segundos */
export const mmss = (s: number) => `${String(Math.floor(Math.max(0, s) / 60)).padStart(2, '0')}:${String(Math.floor(Math.max(0, s) % 60)).padStart(2, '0')}`;

export const initials = (name: string) => name.split(' ').filter(Boolean).slice(0, 2).map((n) => n[0]).join('').toUpperCase();
